import * as React from "react";
import * as moment from "moment";
import { AbstractDocument } from "../model/autogen/AbstractDocument";


export interface IDocumentMetadataDisplayProps {
    model: AbstractDocument;
    showCreatedOn?: boolean;
    showPublishedOn?: boolean;
}

export const DocumentMetadataDisplay = (props: IDocumentMetadataDisplayProps) => {
    const { model, showCreatedOn, showPublishedOn } = props;
    if (model.isDeleted && model.isDeleted === true) {
        return <p>This content has been archived and can no longer be edited</p>;
    }
    return <>
        {showCreatedOn === true && <p><small>Created on <strong>{moment(model.date).format("LLL")}</strong> by ({model.createdByUser || "<unspecified user>"})</small></p>}
        <>{(model.lastUpdated != null) && <p><small>Last updated at <strong>{moment(model.lastUpdated).format("LLL")}</strong> by ({model.updatedByUser || "<unspecified user>"})</small></p>}</>
        {showPublishedOn === true && <>{(model.isPublished == true) && <p><small>Published by ({model.publishedByUser || "<unspecified user>"}) on <strong>{moment(model.publishedOn).format("LLL")}</strong></small></p>}</>}
    </>;
}


// WEBPACK FOOTER //
// ./src/components/document-metadata-display.tsx